import React from 'react';
import { addNotification } from '../../action/notificationAction';
import { logoutUser } from '../../action/userActions';
import { Nav } from 'react-bootstrap';
import { publishData, locallyPersistData, loadLocalData, newTree, getTreeFromDb } from '../../services/publishData';
import { csvManager } from '../../services/csvManager';
import LoadModal from '../tree/treeHeader/loadTree';
import { imageSaver } from '../../services/imageManager';
import { setPublish } from '../../action/tableActions';
import userStore from "../../store/userStore";
import tableStore from '../../store/tableStore';
import { withRouter } from "react-router";

/**Navbar handles what a user can see in there UI
 * depending what page and if you're admin will differ what you can see
 */
class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogout: true
        };
    }
    // componentDidMount
    componentWillMount() {
        this.setState({ pathName: this.props.history.location.pathname });
        const pathName = this.props.history.location.pathname;
        let navMapper = [];
        navMapper.push({ title: "Home", onClick: this.onHomeClick });
        if (pathName === "/tree") {
            navMapper.push({ title: "Save Tree", onClick: this.onClickOnlineSave });
            navMapper.push({ title: "Reload Tree", onClick: this.onClickTreeReload });
            if(userStore.user.privilege === "ADMIN"){
                navMapper.push({ title: "Save CSV", onClick: this.onClickSaveCSV });
            }
            navMapper.push({ title: "Save Image", onClick: this.onClickSavePNG });

        } else {
            navMapper.push({ title: "View Tree", onClick: this.onTreeClick });
        }
        if (userStore.user.privilege === "ADMIN") {
            navMapper.push({ title: "Create Company", onClick: this.onAdminClick });
            navMapper.push({ title: "View Companies", onClick: this.onAdminControllerClick });
            navMapper.push({ title: "Publish Tree", onClick: this.onAdminPublishClick });
        }
        this.setState({ navMapper });
    }
    onClickTreeReload = () => {
        addNotification({ status: "success", message: "Reloading tree... this may take a couple moments" });
        getTreeFromDb(tableStore.table.companyId);
        //tree reloader
    };

    onClickSaveCSV = () => {
        addNotification({ status: "success", message: "Saving CSV.." });
        csvManager();
    };
    onClickSavePNG = () => {
        addNotification({ status: "success", message: "Saving PNG.." });
        imageSaver();
    };
    onLogout = () => {
        addNotification({ status: "sucess", message: "Logging out.. Bye" });
        logoutUser();
    };
    onClickLocalLoad = () => {
        addNotification({ status: "success", message: "Loading local data.." });
        loadLocalData();
    };
    onClickLocalSave = () => {
        addNotification({ status: "saving", message: "Saving locally.." });
        locallyPersistData();
    };
    onClickOnlineSave = () => {
        addNotification({ status: "saving", message: "Saving.." });
        publishData();
    };
    onNewTreeClick = () => {
        addNotification({ status: "success", message: "Creating new tree.." });
        newTree();
    };
    publishFlag = () => {
        addNotification({ status: "saving", message: "Publishing flag set, save to confirm" });
        setPublish();
    };
    onAdminClick = () => this.props.history.push("/admin");
    onLoadTree = () => this.props.showModal();
    onHomeClick = () => this.props.history.push("/home");
    onTreeClick = () => this.props.history.push("/tree");
    onAdminPublishClick = () => this.props.history.push("/adminPublish");
    onAdminCreatedClick = () => this.props.history.push("/adminCreated");
    onAdminControllerClick = () => this.props.history.push("/adminController");

    onLogoutClick = () => {
        this.props.history.push("/");
        logoutUser();
    };
    // hacky to remove an error
    select = () => { };
    render() {
        const nav = this.state.navMapper.map((navs, index) => {
            return (
                <Nav.Item key={index}>
                    <Nav.Link onClick={navs.onClick} >{navs.title}</Nav.Link>
                </Nav.Item>
            );
        });
        return (
            <div>
                <LoadModal show={this.props.show} hide={this.props.hide} />
                <Nav variant="tabs" className="mr-auto" activeKey={this.state.pathName} onSelect={this.select}>
                    {nav}
                    {this.state.showLogout ? < Nav.Link onClick={this.onLogoutClick}>Logout</Nav.Link> : null}
                </Nav>
            </div >
        );
    }
}
export default withRouter(NavBar);


// WEBPACK FOOTER //
// ./src/components/header/NavBar.js